import i18n from "src/i18n/config";
import { z } from "zod";

const zipCodeRegex = /^[a-zA-Z0-9\s-]+$/;

export const validationSchema = z.object({
    name: z.string().max(30),
    address: z.string().max(30),
    zipCode: z.string().regex(zipCodeRegex, i18n.t("common:validation.zipCode")),
    city: z.string().max(30),
    country: z.string(),
});
